import { FlyoutDrsFileInfoQuery } from "graphql/_Types";
import { FlyoutFileInfoBodyPreviews } from "./FlyoutFileInfoBodyPreviews";
import {
  FlyoutFileInfoBodyBasicInfo,
  FlyoutFileInfoBodyBasicInfoProps,
} from "./FlyoutFileInfoBodyBasicInfo";
import { FlyoutFileInfoBodyMetadata } from "./FlyoutFileInfoBodyMetadata";
import { ComponentType } from "react";

export interface FlyoutFileInfoBodyProps
  extends Pick<FlyoutFileInfoBodyBasicInfoProps, "drsFileAnalysisTableInfo"> {
  activeFile: Pick<
    NonNullable<FlyoutDrsFileInfoQuery["drsFile"]>,
    | "id"
    | "fileType"
    | "status"
    | "size"
    | "source"
    | "dateCreated"
    | "userId"
    | "preview"
    | "name"
    | "processingStatus"
    | "tags"
  >;
  assignments: ComponentType<{ fileId: string }>;
}
export const FlyoutFileInfoBody = ({
  activeFile,
  assignments,
  drsFileAnalysisTableInfo,
}: FlyoutFileInfoBodyProps) => {
  return (
    <>
      <FlyoutFileInfoBodyBasicInfo
        activeFile={activeFile}
        assignments={assignments}
        drsFileAnalysisTableInfo={drsFileAnalysisTableInfo}
      />
      <FlyoutFileInfoBodyMetadata activeFile={activeFile} />
      <FlyoutFileInfoBodyPreviews activeFile={activeFile} />
    </>
  );
};
